import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useComputed, useSignal, useSignalEffect } from "@preact/signals";
import isUndefined from "@tinkoff/utils/is/undefined";
import { flattenOptionGroup } from "../../../lib/filter/filter-collection";
import { numberOrUndefined } from "../../../lib/number";
import DropDownMenu from "../../DropDownMenu";
import TextInput from "../../Form/TextInput";
import FilterPill from "../FilterPill";
import style from "./style.module.scss";
export default function MetricThresholdFilter(props) {
    var _a, _b, _c;
    const { name, options, defaultValue, open, removable, disabled, onChange, onRemove } = props;
    const selectedMetric = useSignal(defaultValue ? findOptionByValue(options, defaultValue.value.metric) : undefined);
    const lowerBound = useSignal(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value.lowerBound);
    const upperBound = useSignal(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value.upperBound);
    useSignalEffect(() => {
        if (onChange && selectedMetric.value && (lowerBound.value || upperBound.value)) {
            onChange({
                label: selectedMetric.value.label,
                value: {
                    metric: selectedMetric.value.value,
                    lowerBound: lowerBound.value,
                    upperBound: upperBound.value,
                },
            });
        }
    });
    const pillName = useComputed(() => {
        if (selectedMetric.value) {
            return selectedMetric.value.label;
        }
        return name;
    });
    const pillOptions = useComputed(() => {
        var _a;
        if (!isUndefined(lowerBound.value) || !isUndefined(upperBound.value)) {
            const suffix = ((_a = selectedMetric.value) === null || _a === void 0 ? void 0 : _a.units) || "";
            const lowerLabel = isUndefined(lowerBound.value) ? "Any" : `${lowerBound.value}${suffix}`;
            const upperLabel = isUndefined(upperBound.value) ? "Any" : `${upperBound.value}${suffix}`;
            return [
                {
                    label: `${lowerLabel} - ${upperLabel}`,
                },
            ];
        }
        return [];
    });
    function handleInputChange(internalValue) {
        return (event) => {
            const parsedValue = numberOrUndefined(parseFloat(event.currentTarget.value));
            if (parsedValue !== undefined) {
                const stringValue = parsedValue.toString();
                if (!stringValue.includes("e")) {
                    internalValue.value = parsedValue;
                }
            }
        };
    }
    return (_jsx(FilterPill, { attributes: props.attributes, panelTitle: name, name: pillName.value, options: pillOptions.value, open: open, removable: removable, disabled: disabled, onRemove: onRemove, children: _jsxs("div", { className: style["metric-threshold-filter"], children: [_jsxs("div", { children: [_jsx("label", { className: style["metric-threshold-filter__label"], children: "Metric" }), _jsx(DropDownMenu, { selected: (_a = selectedMetric.value) === null || _a === void 0 ? void 0 : _a.value, searchable: true, displayType: "text-input", sections: options, onChange: (value) => (selectedMetric.value = value) })] }), _jsxs("div", { children: [_jsx("label", { className: style["metric-threshold-filter__label"], children: "Min" }), _jsx(TextInput, { suffix: (_b = selectedMetric.value) === null || _b === void 0 ? void 0 : _b.units, defaultValue: lowerBound.value, onInput: handleInputChange(lowerBound) })] }), _jsxs("div", { children: [_jsx("label", { className: style["metric-threshold-filter__label"], children: "Max" }), _jsx(TextInput, { suffix: (_c = selectedMetric.value) === null || _c === void 0 ? void 0 : _c.units, defaultValue: upperBound.value, onInput: handleInputChange(upperBound) })] })] }) }));
}
function findOptionByValue(options, value) {
    return flattenOptionGroup(options).find((option) => option.value === value);
}
